/**
 * 日历
 */

'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import { observer, inject } from 'mobx-react';

import { FloatCalendar } from '@qnpm/q-calendar';

@inject(stores => {
    const {searchDataStore} = stores,
        {calendarInfo, calendarVisible, handleCalendarStatus} = searchDataStore;

    return {
        calendarInfo,
        calendarVisible,
        handleCalendarStatus
    };
})

@observer
class Calendar extends Component {

    closeCalendar = () => {
        this.props.handleCalendarStatus(false);
    };

    render() {
        const {calendarInfo, calendarVisible} = this.props || {};
        if(!calendarInfo) {
            return <View />
        }
        const {minDate, maxDate, selectedPayLoad, selectedDate, limitInfo, buttons, getMergeDesc, canSelectSameDay} = calendarInfo || {};

        return (
            <FloatCalendar
                canSelectSameDay={canSelectSameDay}
                startTime={minDate}
                endTime={maxDate}
                animationType={'none'}
                visible={calendarVisible}
                mode={'range'}
                getMergeDesc={getMergeDesc}
                selectedPayload={selectedPayLoad}
                limitInfo = {limitInfo}
                buttons={buttons}
                minDate={minDate}
                maxDate={maxDate}
                selectedDate={selectedDate}
                onClose={this.closeCalendar}
            />
        )
    }
}

export default Calendar;
